import {useEffect, useState} from 'react';

const withJobInProgress = (Slide) => {
  return (props) => {
    const {session} = props;

    const [job, setJob] = useState(null);

    useEffect(() => {
      if (session) {
        const details = {...(session.job ?? {})};
        let update = false;
        if (session.selectedCompany?.id) {
          details.company_id = session.selectedCompany.id;
          update = true;
        }
        if (session.selectedContact?.id) {
          details.contact_id = session.selectedContact.id;
          update = true;
        }
        if (session.selectedEndUser?.id) {
          details.end_user_id = session.selectedEndUser.id;
          update = true;
        }
        if (update) {
          setJob(details);
          return;
        }
      }
      setJob({});
    }, [session]);

    return <Slide job={job} {...props}/>;
  }
};

export default withJobInProgress;
